/** @module SiteAdmin/PhaseRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/locale"
], function(declare,Ref,locale) {
	
	/**
	 * NOTE: A better solution for Phase would be to either derive the class from LocalizedItem or change to an enum.
	 */

	return declare(Ref, {
 		/**
 		 * @override
 		 * Return localized value of phase - only used if formatValue called independently on renderer such as from csi/store/Values (not in usual flow of Ref renderer) 
 		 */
		formatValue: function(value, fmt) {
 			return locale.getIndexName(value);
 		},

		/**
		 * @override
		 * Return localized value of phase - display name resolver is not considered by base class 
		 */
		formatValueForFiltering: function(ctx, h, value) {
			return locale.getIndexName(value);
		},

		/**
		 * @override
		 * Use this renderer (rather than basic string renderer) to handle formatting of query values 
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.ren = this;
			return qs;
		},

		/**
		 * @override
		 * Make sure selected value is in store
		 */
		toHtmlQueryFilter: function(ctx, spec, refNode, params) {
			if (params.value) {
				params.store.addSelectedValue(params.value);
			}
			
			return this.inherited(arguments);
		}
	});
});